(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-gallery"] && !Shopify.designMode) return;
  try {
    

  class FeaturedGallery extends HTMLElement {
    constructor() {
      super();
      this.mediaItems = this.querySelectorAll('.featured-gallery__media');
      this.titleItems = this.querySelectorAll('.featured-gallery__title');
      this.enabledMobAutoplay = this.classList.contains('featured-gallery--mob-autoplay');
      this.currentIndex = 0;
      this.autoplayInterval = null;
      this.userInteracted = false;
      
      this.initEventListeners();
      this.initAutoplay();
    }
    
    initEventListeners() {
      if (window.innerWidth >= 990) {
        this.titleItems.forEach(title => {
          title.addEventListener('mouseenter', this.handleTitleInteraction.bind(this));
        });
      } else {
        this.titleItems.forEach(title => {
          title.addEventListener('click', this.handleTitleInteraction.bind(this));
        });
      }
      
      window.addEventListener('resize', () => {
        this.clearAutoplay();

        this.titleItems.forEach(title => {
          title.removeEventListener('mouseenter', this.handleTitleInteraction);
          title.removeEventListener('click', this.handleTitleInteraction);
        });
        
        if (window.innerWidth >= 990) {
          this.titleItems.forEach(title => {
            title.addEventListener('mouseenter', this.handleTitleInteraction.bind(this));
          });
        } else {
          this.titleItems.forEach(title => {
            title.addEventListener('click', this.handleTitleInteraction.bind(this));
          });
        }

        this.initAutoplay();
      });
    }
    
    handleTitleInteraction(e) {
      this.userInteracted = true;
      this.clearAutoplay(); 
      
      const targetIndex = e.currentTarget.dataset.index;
      this.currentIndex = parseInt(targetIndex, 10);
      this.showItem(this.currentIndex);
    }

    initAutoplay() {
      if (this.enabledMobAutoplay && window.innerWidth < 990) {
        this.showItem(this.currentIndex);

        this.autoplayInterval = setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.titleItems.length;
          this.showItem(this.currentIndex);
        }, 2500);
      }
    }

    clearAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    showItem(index) {
      const targetIndex = String(index);

      this.mediaItems.forEach(media => {
        media.classList.toggle('active', media.dataset.index === targetIndex);
      });

      this.titleItems.forEach(title => {
        title.classList.toggle('active', title.dataset.index === targetIndex);
      });
    }
  }

  if (!customElements.get('featured-product-card')) {
    customElements.define('featured-gallery', FeaturedGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.getElementById('darkModeToggle');

    if (
      localStorage.getItem('theme') === 'dark' ||
      (window.matchMedia('(prefers-color-scheme: dark)').matches && !localStorage.getItem('theme'))
    ) {
      toggle.checked = true;
      document.documentElement.setAttribute('data-theme', 'dark');
      toggle.setAttribute('aria-checked', 'true');
    }

    if(toggle){
      toggle.addEventListener('change', function () {
        const isDark = this.checked;
        document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
        this.setAttribute('aria-checked', String(isDark));
      });
    }

    const label = document.querySelector('.dark-mode-toggle__label');
    if(label){
      label.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
